module.exports = __webpack_public_path__ + "static/media/snowfall_2.7e2fb033.png";